import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

interface CsvData {
  columns: string[];
  rows: Record<string, string>[];
}

@Injectable({ providedIn: 'root' })
export class CsvService {

  private httpBypass: HttpClient;

  constructor(private http: HttpClient, private httpBackend: HttpBackend) {
    // Creamos un HttpClient que omite todos los interceptores
    this.httpBypass = new HttpClient(this.httpBackend);
  }
  /**
   * Parsea CSV completo (soporta comas dentro de comillas y comillas escapadas).
   */
  private parseCSV(csv: string): CsvData {
    const lines = csv.trim().split(/\r?\n/);
    const header = lines.shift() ?? '';
    const columns = this.parseLine(header);
    const rows = lines.map(line => {
      const values = this.parseLine(line);
      const obj: any = {};
      columns.forEach((col, i) => obj[col] = values[i] ?? '');
      return obj;
    });
    return { columns, rows };
  }

  private parseLine(line: string): string[] {
    const result: string[] = [];
    let field = '';
    let inQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        if (inQuotes && line[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        result.push(field);
        field = '';
      } else {
        field += char;
      }
    }
    result.push(field);
    return result.map(f => f.trim());
  }

  /**
   * Obtiene y parsea el CSV desde la URL pública.
   */
  getCsvData(url: string): Observable<CsvData> {
    return this.httpBypass.get(url, { responseType: 'text' }).pipe(
      map(text => this.parseCSV(text))
    );
  }
}
